import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router'; 
import { SharedModule } from '../../shared/shared.module';
import { MesRevenusComponent } from './mes-revenus/mes-revenus.component';
import { MesPaiementsComponent } from './mes-paiements/mes-paiements.component';
import { IncomeTableComponent } from './income-table/income-table.component';
import { TransferTableComponent } from './transfer-table/transfer-table.component';
import { TransferCreateComponent } from './transfer-create/transfer-create.component';
import { MesAvoirsComponent } from './mes-avoirs/mes-avoirs.component';
import { MonPorteMonaieComponent } from './mes-paiements/mon-porte-monaie/mon-porte-monaie.component';
import { MonPorteMonaieValideComponent } from './mes-paiements/mon-porte-monaie-valide/mon-porte-monaie-valide.component';
import { NgxStarRatingModule } from 'ngx-star-rating';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouteProprietaireGuard } from 'src/app/services/guards/routeProprietaireGuard.guard';
import { RouteLocataireGuard } from 'src/app/services/guards/routeLocataireGuard.guard';
export const routes: Routes = [ 
  { path: '', redirectTo: 'list', pathMatch: 'full'},
  { path: 'mes-revenus',canActivate: [RouteProprietaireGuard], component: MesRevenusComponent, data: { breadcrumb: 'Mes revenus' }},
  { path: 'mes-paiements',canActivate: [RouteLocataireGuard], component: MesPaiementsComponent, data: { breadcrumb: 'Mes paiements' }},
  { path: 'mes-avoirs',canActivate: [RouteLocataireGuard], component: MesAvoirsComponent, data: { breadcrumb: 'Mes avoirs' }},
  { path: 'mon-porte-monaie',canActivate: [RouteProprietaireGuard], component: MonPorteMonaieComponent, data: { breadcrumb: 'Mon Porte monaie' }},
  { path: 'mon-porte-monaie-valide', canActivate: [RouteProprietaireGuard],component: MonPorteMonaieValideComponent, data: { breadcrumb: 'Mon Porte monaie' }}
  
  
];

@NgModule({
  declarations: [
    MesRevenusComponent,
    MesPaiementsComponent,
    IncomeTableComponent,
    TransferTableComponent,
    TransferCreateComponent,
    MesAvoirsComponent,
    MonPorteMonaieComponent,
    MonPorteMonaieValideComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    SharedModule,
    NgxStarRatingModule,
    NgxSpinnerModule,
    NgxPaginationModule,
  ]
})
export class MesPaiementsModule { }
